// Scenario 3a: past_due_us_yellow
// Same as past_due_us but pastDueSince = now - 0d (just failed).
// daysRemaining = 7 -> yellow severity (#06).

import { pastDueUs } from './past-due-us.fixture';
import { Scenario, daysFromNow } from './scenario.types';

export const pastDueUsYellow: Scenario = {
  ...pastDueUs,
  name: 'past_due_us_yellow',
  subscription: pastDueUs.subscription
    ? {
        ...pastDueUs.subscription,
        id: 'sub_past_due_us_yellow',
        pastDueSince: daysFromNow(0),
        gracePeriodEndsAt: daysFromNow(7)
      }
    : null
};
